import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AssetDetailsDto, AssetService } from '@proxy/register-service/assets';
import { ModelService } from '@proxy/register-service/models';

@Component({
  selector: 'app-detail-models',
  templateUrl: './detail-models.component.html',
  styleUrls: ['./detail-models.component.scss'],
})
export class DetailModelsComponent implements OnInit, OnChanges {
  @Input() asset: AssetDetailsDto;

  costCentreName = '';
  isCostCentreFixed = false;

  constructor(
    public readonly service: AssetService,
    public readonly toasterService: ToasterService,
    private readonly modelService: ModelService
  ) {}

  ngOnInit() {
    this.getCostCentre();
    this.isCostCentreFixed = !!this.asset.isFixed;
  }

  ngOnChanges({ asset }: SimpleChanges) {
    if (asset?.currentValue && !asset.firstChange) {
      this.getCostCentre();
    }
  }

  changeStatus(val: boolean) {
    if (!this.asset) return;

    const request = this.service.updateStatus(this.asset.id);

    request.subscribe({
      next: () => {
        this.isCostCentreFixed = val;

        if (!val) this.getCostCentre();
        this.toasterService.success('ServicingService::SuccessfullySaved');
        return;
      },
      error: error => {
        this.service.handleErrorResponse(error);
      },
    });
  }

  getCostCentre(): void {
    this.service.getCostCenter(this.asset.id).subscribe({
      next: data => {
        this.costCentreName = data?.name || '';
      },
    });
  }
}
